import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 箱货信息
export function seaEQList(params) {
  return request({
    url: URL.seaExport.seaEQ,
    method: 'get',
    params
  })
}
